import React from "react";
import { FormGroup, RadioGroup } from 'xsolla-uikit';
import { policyTypes, policies } from './PAgkRefund';



export const PArefundLevelSelect = ({
  level = 'loyal',
  handleChange = nw => void 0,
}) => {
  return (
    <div className="">



        <RadioGroup
          name="radio"
          direction="row"
          input={{
            value: level,
            onChange: e => handleChange(e.target.value),
            }
          }
          options={[
            ...Object.keys(policyTypes).map((oneTypeId, ind)=> ({
              label: policyTypes[oneTypeId]['title'],
              radioValue: oneTypeId,
              tooltip: policyTypes[oneTypeId]['tooltip'],
            }))
          ]}
        />
    </div>
  )
}


export const PArefundLevelSelect1 = ({
  level,
  handleChange = nw => void 0,
  staticLevel,
}) => {
  return (
  <FormGroup label="" indentation="md">


    {staticLevel && <div className="xsui-radio_group__wrapper xsui-radio_group__wrapper--direction-row" style={{ height: 90 }}>
      <label className={level === "loyal"
        ? "xsui-radio_group__items--background xsui-radio_group__items--background-selected"
        : "xsui-radio_group__items--background"} style={{
          height: 90,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }} onClick={e => {
          handleChange("loyal");
        }}>
        <div className="xsui-radio">{staticLevel}</div>
      </label>
    </div>}


    {!staticLevel && <div className="xsui-radio_group__wrapper xsui-radio_group__wrapper--direction-row" style={{ height: 90 }}>
      <label className={level === "loyal"
        ? "xsui-radio_group__items--background xsui-radio_group__items--background-selected"
        : "xsui-radio_group__items--background"} style={{
          height: 90,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }} onClick={e => {
          handleChange("loyal");
        }}>
        <div className="xsui-radio">Loyal</div>
      </label>
      <label className={level === "moderate"
        ? "xsui-radio_group__items--background xsui-radio_group__items--background-selected"
        : "xsui-radio_group__items--background"} style={{
          height: 90,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }} onClick={e => {
          handleChange("moderate");
        }}>
        <div className="xsui-radio">Moderate</div>
      </label>
      <label className={level === "strict"
        ? "xsui-radio_group__items--background xsui-radio_group__items--background-selected"
        : "xsui-radio_group__items--background"} style={{
          height: 90,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }} onClick={e => {
          handleChange("strict");
        }}>
        <div className="xsui-radio">Strict</div>
      </label>
    </div>}



  </FormGroup>);
};
